import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import CircleButton from '../../components/CircleButton';
import HydrantManufacturerRow from '../../components/hydrantManufacturers/HydrantManufacturerRow';
import { getHydrantManufacturers, deleteHydrantManufacturer } from '../../services/api';

const HydrantManufacturers = () => {
  const [hydrantManufacturers, setHydrantManufacturers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setupHydrantManufacturers();
  }, []);

  const setupHydrantManufacturers = async () => {
    setLoading(true);
    const result = await getHydrantManufacturers();
    const resultSorted = result.sort((a, b) => (a.name <= b.name ? -1 : 1));
    setHydrantManufacturers(resultSorted);
    setLoading(false);
  };

  const onDelete = async id => {
    await deleteHydrantManufacturer(id);
    await setupHydrantManufacturers();
  };

  const rows = hydrantManufacturers?.map((hydrantManufacturer, index) => (
    <HydrantManufacturerRow key={index} hydrantManufacturer={hydrantManufacturer} onDelete={onDelete} />
  ));

  return (
    <div id="hydrantManufacturers" className="list">
      <h2>Hydrant Manufacturers</h2>
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>Address</th>
              <th>City</th>
              <th>State</th>
              <th>Phone</th>
              <th>Email</th>
              <th className="command-row">
                <Link to={'hydrantManufacturers/add'}>
                  <CircleButton icon={faPlus} type="success" title="Add Hydrant Manufacturer" />
                </Link>
              </th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default HydrantManufacturers;
